<template>
  <div class="shrink-0 *:rounded-full">
    <img
      v-if="partner.uri_photo"
      :src="partner.uri_photo"
      :alt="partner.first_name"
      :class="photoSize"
    />
    <div
      v-else
      class="flex bg-neutral-200"
      :class="photoSize"
    >
      <fa
        :icon="['fal', 'user-md']"
        class="fa-fw m-auto text-3xl"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'VetsterPartnerPhoto',

  props: {
    partner: {
      type: Object,
      required: true,
    },
    photoSize: {
      type: String,
      default: 'size-12',
    },
  },
};
</script>
